// extracted by css-extract-rspack-plugin
export default {"colorRed":"#ea3556","colorWhite":"#fff","topNavBubble":"messages-nav-link__topNavBubble___BULqM"};